// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"Y1-z","displaySixCardTiles":"Z1-z"};